import request from "@utils/request";

const SearchApiService = {
    /**
     * 查询
     * @param sApi 导出接口
     * @param postParam  传参

     * @param callback
     * @returns {Function}
     */
    fetch(sApi,postParam={}) {
        return request({
            url:  sApi,
            method: "POST",
            data:postParam
        });
    }
};

export default SearchApiService;
